/**
 * The currencies a guest can switch the site into.
 *
 * Shared rather than owned by the web app, because the two consumers have to
 * agree: the header switcher decides what a guest may pick, and the stays API
 * decides what it will ask the supplier to quote in. While the list lived only
 * in apps/majourneys/src/lib/currency.tsx the API had no notion of currency at
 * all and every hotel price came back in MAD regardless of the selection, so a
 * guest browsing in USD saw "10,274 MAD per night".
 *
 * MAD stays first and is the default: it is the currency the supplier prices
 * in by default and the one every stored `fromPriceNightly` is denominated in.
 */
export const SUPPORTED_CURRENCIES = ["MAD", "USD", "EUR", "GBP"] as const;

export type CurrencyCode = (typeof SUPPORTED_CURRENCIES)[number];

export const DEFAULT_CURRENCY: CurrencyCode = "MAD";

export function isSupportedCurrency(value: string): value is CurrencyCode {
  return (SUPPORTED_CURRENCIES as readonly string[]).includes(value);
}
